// LinkTargetPlugin.js
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { LinkNode } from "@lexical/link";

export function LinkTargetPlugin() {
	const [editor] = useLexicalComposerContext();

	useEffect(() => {
		return editor.registerNodeTransform(LinkNode, (node) => {
			// Set target="_blank" if it's not already set
			if (node.getTarget() !== "_blank") {
				node.setTarget("_blank");
			}
		});
	}, [editor]);

	return null;
}
